import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ModalController, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../../../dic';
import { GN } from '../../../../gn';
import * as moment from 'moment';
import { PopupPage } from '../../../popup/popup';
import { CalendarPage } from '../../../calendar/calendar';
import { QualitycontrolquestionsPage } from './qualitycontrolquestions/qualitycontrolquestions';

/**
 * Generated class for the QualitycontrolPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-qualitycontrol',
  templateUrl: 'qualitycontrol.html',
})
export class QualitycontrolPage {
  // this.selDay = moment(this.selDay).add(_d, 'years').format('YYYY-MM-DD')

  startDateA: any = moment().startOf('year');//moment(new Date()).add(-3, 'month')
  startDateStrA: any = moment().startOf('year').format(this.gn.user.DFormat);//moment(new Date()).add(-3, 'month').format(this.gn.user.DFormat)
  startDateB: any = moment(new Date()).add(0, 'days')
  startDateStrB: any = moment(new Date()).add(0, 'days').format(this.gn.user.DFormat)

  loadingData = false
  donetxt = this.dic.l["done"]
  canceltxt = this.dic.l["cancel"]

  reportData = []


  reportDataToday = []
  reportDataOld = []
  reportDataNew = []
  reportDDD = []

  Denes = moment(new Date()).format('YYYY-MM-DD')
  Denesenden: any = moment(new Date()).add(-1, 'days')

  sortOrder = false
  sortDt = false
  sortRok = false
  sortArticle = false
  sortPercent = false
  sortSnum = false

  filterSite = false
  filterNezapocnati = false
  filterNedovrseni = false
  filterDovrseni = false
  filterFinala = false
  filterTapetarija = false

  cntsite = 0;
  cntnezapocnati = 0;
  cntnedovrseni = 0;
  cntdovrseni = 0;
  cntfinala = 0;
  cnttapetarija = 0;

  m_sd = this.startDateA.toISOString();
  m_ed = this.startDateB.toISOString();

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public popoverCtrl: PopoverController, public modalCtrl: ModalController, public toastCtrl: ToastController, public alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad QualitycontrolPage');
    this.loadReport();
  }

  //za mobilnata
  ionDtChange(_ev, _i) {
    var _v = moment(_ev.value.year + '-' + (_ev.value.month < 10 ? '0' + _ev.value.month : _ev.value.month) + '-' + (_ev.value.day < 10 ? '0' + _ev.value.day : _ev.value.day)).format('YYYY-MM-DD');
    if (_i == 'start') {
      var ddiff1 = this.getDateDifff(_v, this.startDateB)
      if (ddiff1 <= 0) {
        this.m_ed = new Date(_v).toISOString();
        this.startDateB = new Date(_v)
      }
      this.startDateA = new Date(_v)
    } else {
      var ddiff2 = this.getDateDifff(this.startDateA, _v)
      if (ddiff2 <= 0) {
        this.m_sd = new Date(_v).toISOString();
        this.startDateA = new Date(_v)
      }
      this.startDateB = new Date(_v)
    }
  }

  openDatePopup(_ev, _se) {
    var dd = this.startDateA
    if (_se == 2) {
      dd = this.startDateB
    }
    var _that = this;
    let popover = this.popoverCtrl.create(CalendarPage, {
      d: dd, cb: function (d) {

        if (_se == 1) {
          var ddiff = _that.getDateDifff(d, _that.startDateB)

          if (ddiff <= 0) {
            _that.startDateB = d;
            _that.startDateStrB = moment(_that.startDateB).format(_that.gn.user.DFormat)
            _that.m_ed = _that.startDateB.toISOString();
          }
          _that.startDateA = d;
          _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)
          _that.m_sd = _that.startDateA.toISOString();

        } else {
          var ddiff = _that.getDateDifff(_that.startDateA, d)
          if (ddiff <= 0) {
            _that.startDateA = d;
            _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)
            _that.m_sd = _that.startDateA.toISOString();
          }
          _that.startDateB = d;
          _that.startDateStrB = moment(_that.startDateB).format(_that.gn.user.DFormat)
          _that.m_ed = _that.startDateB.toISOString();
        }

        var alertMinusDenesenDen = _that.getDateDifff(_that.startDateB, _that.Denesenden)
        if (alertMinusDenesenDen == 0) {
          alertMinusDenesenDen = -1
        }
        // console.log(alertMinusDenesenDen, 'alertMinusDenesenDen')
        // if (Math.sign(alertMinusDenesenDen) == -1) {
        //   _that.startDateB = moment(new Date()).add(-1, 'days')
        //   _that.startDateStrB = moment(_that.startDateB).format(_that.gn.user.DFormat)

        //   _that.startDateA = moment(new Date()).add(-1, 'days')
        //   _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)

        //   const toast = _that.toastCtrl.create({ message: _that.dic.l["IzbravteLosKraenDatum"], duration: 3000, position: 'top' });
        //   toast.present();
        //   return
        // }
      }
    })
    popover.present({ ev: _ev });
  }

  getDateDifff(_d1, _d2) {
    var d1 = moment(moment(_d1).format('YYYY-MM-DD')); //todays date
    var d2 = moment(moment(_d2).format('YYYY-MM-DD')); //todays date
    var momentalendate = moment(moment(this.Denesenden).format('YYYY-MM-DD')); //todays date
    var duration = moment.duration(d2.diff(d1));
    var days = 1 + duration.asDays();
    return days
  }

  getDateDifffMonth(_d1, _d2) {
    var d1 = moment(moment(_d1).format('YYYY-MM-DD')); //todays date
    var d2 = moment(moment(_d2).format('YYYY-MM-DD')); //todays date
    var duration = moment.duration(d2.diff(d1));
    var months = duration.asMonths();
    return parseInt(months + '')
  }


  sec2str2(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

  loadReport() {
    this.filterSite = false
    this.filterNezapocnati = false
    this.filterNedovrseni = false
    this.filterDovrseni = false
    this.filterFinala = false
    this.filterTapetarija = false

    this.cntsite = 0;
    this.cntnezapocnati = 0;
    this.cntnedovrseni = 0;
    this.cntdovrseni = 0;
    this.cntfinala = 0;
    this.cnttapetarija = 0;

    this.sortOrder = false
    this.sortDt = false
    this.sortRok = false
    this.sortArticle = false
    this.sortPercent = false
    this.sortSnum = false

    //this.showReportPanel = true
    this.loadingData = true
    this.reportData = []
    // var new_date = moment(this.startDateA, "DD-MM-YYYY").add(5, 'days');

    var d1 = moment(this.startDateA).format('YYYY-MM-DD')
    var d2 = moment(this.startDateB).format('YYYY-MM-DD')

    var _dat = {
      d1: this.gn.crypt(d1),
      d2: this.gn.crypt(d2),
      cid: this.gn.crypt(this.gn.user.ClientId),
      percent: this.gn.crypt('=100')
    }

    var _that = this
    this.gn._Post('/api/gn/getrouteindoorreport', _dat, function (_data) {
      _that.cntsite = _data.datacnt[0].sitecnt;
      _that.cntnezapocnati = _data.datacnt[0].nezapocnaticnt;
      _that.cntnedovrseni = _data.datacnt[0].nedovrsenicnt;
      _that.cntdovrseni = _data.datacnt[0].dovrsenicnt;
      _that.cntfinala = _data.datacnt[0].finalacnt;
      _that.cnttapetarija = _data.datacnt[0].tapetarijacnt;

      _data = _data.data
      for (var i = 0; i < _data.length; i++) {
        _data[i].datumcreate = moment(_data[i].dt_create).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
        _data[i].orgdt = _data[i].dt
        _data[i].dt = moment(_data[i].dt).format(_that.gn.user.DFormat)//moment(_data[i].dt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
        _data[i].orgrokizrabotka = _data[i].rokizrabotka
        _data[i].rokizrabotka = moment(_data[i].rokizrabotka).format(_that.gn.user.DFormat)//moment(_data[i].rokizrabotka).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)

        _data[i].crimp = _data[i].byapi + '' == '1' ? _that.dic.l["importedPantheon"] : _that.dic.l["createdPanorama"]
        _data[i].cartnames = (_data[i].cartnames + '' == '' || _data[i].cartnames == null) ? '/' : _data[i].cartnames
        _data[i].komentar = (_data[i].komentar + '' == '' || _data[i].komentar == null) ? '' : _data[i].komentar

        _data[i].visible = true;

        _data[i].dt_done = moment(_data[i].dt_done).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
        _data[i].dt_create = moment(_data[i].dt_create).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
      }
      _that.loadingData = false
      var _lasttourid = ''
      _that.reportData = _data
    })
  }

  sort(_what) {
    var _that = this
    if (_what == 'no') {
      this.reportData.sort(function (a, b) {
        if (!_that.sortOrder) {
          return a.title > b.title ? 1 : -1;
        } else {
          return a.title < b.title ? 1 : -1;
        }
      });
      this.sortOrder = !this.sortOrder
    }
    if (_what == 'dt') {
      this.reportData.sort(function (a, b) {
        var dateA = new Date(a.orgdt).getTime();
        var dateB = new Date(b.orgdt).getTime();
        if (!_that.sortDt) {
          console.log('true')
          return dateA > dateB ? 1 : -1;
        } else {
          console.log('false')
          return dateA < dateB ? 1 : -1;
        }
      })
      this.sortDt = !this.sortDt
    }
    if (_what == 'rokizrabotka') {
      this.reportData.sort(function (a, b) {
        var dateA = new Date(a.orgrokizrabotka).getTime();
        var dateB = new Date(b.orgrokizrabotka).getTime();
        if (!_that.sortRok) {
          console.log('true')
          return dateA > dateB ? 1 : -1;
        } else {
          console.log('false')
          return dateA < dateB ? 1 : -1;
        }
      })
      this.sortRok = !this.sortRok
    }
    if (_what == 'article') {
      this.reportData.sort(function (a, b) {
        if (!_that.sortArticle) {
          return a.article > b.article ? 1 : -1;
        } else {
          return a.article < b.article ? 1 : -1;
        }
      });
      this.sortArticle = !this.sortArticle
    }
    if (_what == 'snum') {
      this.reportData.sort(function (a, b) {
        if (!_that.sortSnum) {
          return a.snumber > b.snumber ? 1 : -1;
        } else {
          return a.snumber < b.snumber ? 1 : -1;
        }
      });
      this.sortSnum = !this.sortSnum
    }
    if (_what == 'percent') {
      this.reportData.sort(function (a, b) {
        if (!_that.sortPercent) {
          return a.percent > b.percent ? 1 : -1;
        } else {
          return a.percent < b.percent ? 1 : -1;
        }
      });
      this.sortPercent = !this.sortPercent
    }
  }
  getItems(ev: any) {
    // for (var i=0; i<this.Data.length; i++){
    //   this.Data[i].visible = true
    // }  
    var val = ''
    if (ev.target.value != undefined) {
      val = ev.target.value.toLowerCase()
    }

    for (var i = 0; i < this.reportData.length; i++) {
      if (val == '') {
        this.reportData[i].visible = true
      } else {
        //debugger
        var itm = this.reportData[i].title.toLowerCase()
        var itm1 = ''
        if (this.reportData[i].article != null)
          itm1 = this.reportData[i].article.toLowerCase()
        var itm2 = ''
        if (this.reportData[i].cartnames != null)
          itm2 = this.reportData[i].cartnames.toLowerCase()
        var itm3 = ''
        if (this.reportData[i].kreiral != null)
          itm3 = this.reportData[i].kreiral.toLowerCase()
        // var itm4 = ''
        // if (this.reportData[i].komentar != null)
        //   itm4 = this.reportData[i].komentar.toLowerCase()

        var itm5 = ''
        if (this.reportData[i].dt != null)
          itm5 = this.reportData[i].dt.toLowerCase()
        var itm6 = ''
        if (this.reportData[i].rokizrabotka != null)
          itm6 = this.reportData[i].rokizrabotka.toLowerCase()
        var itm7 = ''
        if (this.reportData[i].snumber != null)
          itm7 = this.reportData[i].snumber.toLowerCase()

        if (this.gn._latcyr(itm).indexOf(val) > -1 || this.gn._cyrlat(itm).indexOf(val) > -1 ||
          this.gn._latcyr(itm1).indexOf(val) > -1 || this.gn._cyrlat(itm1).indexOf(val) > -1 ||
          this.gn._latcyr(itm2).indexOf(val) > -1 || this.gn._cyrlat(itm2).indexOf(val) > -1 ||
          this.gn._latcyr(itm3).indexOf(val) > -1 || this.gn._cyrlat(itm3).indexOf(val) > -1 ||
          //this.gn._latcyr(itm4).indexOf(val) > -1 || this.gn._cyrlat(itm4).indexOf(val) > -1 ||

          this.gn._latcyr(itm5).indexOf(val) > -1 || this.gn._cyrlat(itm5).indexOf(val) > -1 ||
          this.gn._latcyr(itm6).indexOf(val) > -1 || this.gn._cyrlat(itm6).indexOf(val) > -1 ||
          this.gn._latcyr(itm7).indexOf(val) > -1 || this.gn._cyrlat(itm7).indexOf(val) > -1
        ) {
          this.reportData[i].visible = true
        } else {
          this.reportData[i].visible = false
        }
      }

    }

  }

  indoorQuestions(drn, idxmaster: number) {
    var _that = this
    let modal = this.modalCtrl.create(QualitycontrolquestionsPage, {
      drn: drn,
      cb: function () {
        //drn.cntq = 1
        _that.loadReport()
      }
    }, { cssClass: "modal-fullscreen3" });
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/routing/routeindoor/qualitycontrol/qualitycontrol.ts